import * as React from 'react';
import {DataGrid} from "@mui/x-data-grid";
import {Box, CircularProgress, Typography} from "@mui/material";
import {useSelector} from "react-redux";
import {format} from "date-fns";
import {getDateInServerTimeZone, isAdminMode, mapOrderStatus} from "../../../core/utils/utils";
import {useLocation} from "react-router";
import EditOrderButton from "./EditOrderButton";
import ConfirmDeliveryButton from "../DeliveryConfirm/ConfirmDeliveryButton";
import {useGetMyOrdersQuery} from "../../../core/api/order-api";

const columns = [
    {field: 'id', headerName: 'id'},
    {field: 'ind', headerName: 'ID', width: 50},
    {
        field: 'edit', headerName: 'Edit order', width: 80, sortable: false, filterable: false,
        renderCell: (params) => {
            return <EditOrderButton orderId={params.row.id}/>;
        },
    },
    {
        field: 'createdAt', headerName: 'Date', width: 100,
        renderCell: (params) =>
            <div>{format(getDateInServerTimeZone(params.row.createdAt), "dd.MM.yyyy")}</div>
    },
    {field: 'fullName', headerName: 'Full name', width: 200,},
    {field: 'productTitle', headerName: 'Product', width: 200},
    {field: 'price', headerName: 'Price', width: 80},
    {
        field: 'status', headerName: 'Status', width: 130, sortable: false, filterable: false,
        renderCell: (params) => {
            return <ConfirmDeliveryButton orderId={params.row.id}/>;
        },
    },
    {
        field: 'statusAdmin', headerName: 'Status', width: 110, sortable: false, filterable: false,
        renderCell: (params) => {
            return  <div>{mapOrderStatus(params.row.status)}</div>;
        },
    },
    {
        field: 'confirmed', headerName: 'Received?', width: 110, sortable: false, filterable: false,
        renderCell: (params) => {
            return params.row.isDeliveryConfirmed ? "Yes" : "No";
        },
    },
    {field: 'phone', headerName: 'Phone', width: 120},
    {field: 'deliveryAddress', headerName: 'Address', width: 200},
    {field: 'isGift', headerName: 'Order type', width: 100,
        renderCell: (params) => {
            if (params.row.isCharity) {
                return "Charity";
            } else {
                return params.row.isGift === true ?  "Gift" : (params.row.isProductInStock === true ? "Order" : "Made to order")
            }
        }},
    {
        field: 'asanaLink',
        headerName: 'Task link',
        width: 250,
        renderCell: (params) => {
            return params.row.asanaLink.includes('http') ?
                <a href={params.row.asanaLink}>{params.row.asanaLink}</a> :
                <p>Task not created</p>
        },
    },

];
export default function OrdersHistory(props) {
    const sessionState = useSelector((state) => state.data.UserSession)
    const employeeEmail = sessionState.authenticated ? sessionState.user.username : ''
    const {data: ordersHistory = [], isFetching} = useGetMyOrdersQuery();
    const location = useLocation();

    return (
        <Box className='page-main-box' sx={{ px: { xs: 1, sm: 2 }, py: { xs: 1, sm: 2 } }}>
            {props.isFetching ?
                <Box sx={{display: 'flex'}}>
                    <CircularProgress/>
                </Box> :
                <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
                    {props.filterAndDownLoad}
                    <Typography gutterBottom variant="body1" component="h3">
                        Order history {props.children}
                    </Typography>

                    <Box sx={{ width: '100%', height: 600, overflowX: 'auto' }}>
                        <DataGrid
                            sx={{ minWidth: 720 }}
                            initialState={{
                                columns: {
                                    columnVisibilityModel: {
                                        id: false,
                                        fullName: isAdminMode(location.pathname),
                                        edit: isAdminMode(location.pathname),
                                        status: !isAdminMode(location.pathname),
                                        statusAdmin: isAdminMode(location.pathname),
                                        confirmed: isAdminMode(location.pathname),
                                    },
                                },
                            }}
                            rows={props.ordersHistory}
                            columns={columns}
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                        />
                    </Box>
                </Box>
            }
        </Box>

    );
}
